import React from 'react';

import type { RicosPluginAddButton } from './../../../ricos-plugins';
import type {
  IToolbarItemConfigTiptap,
  IToolbarSettings,
  PublisherProvider,
  ToolbarButtonRenderers,
} from './../../../ricos-types';
import { TOOLBARS } from './../../../editor-common';

import { ToggleButton } from '../../components/buttons';
import type { Topics } from '../../topics';
import type { ToolbarServices } from '../../types';
import { RicosToolbar } from '../ricos-toolbar';

export class FooterToolbar extends RicosToolbar<TOOLBARS.FOOTER> {
  constructor(
    isMobile: boolean,
    services: ToolbarServices,
    publishers: PublisherProvider<Topics>,
    settings: IToolbarSettings<TOOLBARS.FOOTER>,
    shouldCreate: boolean
  ) {
    super(isMobile, services, TOOLBARS.FOOTER, publishers, settings);
    this.isEmpty = () => !shouldCreate;
  }

  getToolbarItemsConfig(options?: { disabled: boolean }): IToolbarItemConfigTiptap[] {
    return this.services.plugins
      .getAddButtons()
      .toToolbarButtonsConfig(TOOLBARS.FOOTER, this.isMobile, options);
  }

  getToolbarItemsRenderers(
    referenceElement?: HTMLElement | null | undefined
  ): ToolbarButtonRenderers {
    const onButtonClick = (addButton: RicosPluginAddButton, event: Event) => {
      const footerToolbarItem = addButton.toFooterToolbarItem();
      return footerToolbarItem.getClickHandler(
        this.services.editor.getPublicCommands(),
        referenceElement || (event.target as HTMLElement)
      )();
    };
    return this.services.plugins
      .getAddButtons()
      .asArray()
      .reduce((result, addButton) => {
        const button = addButton.getButton();
        return {
          ...result,
          [button.id]: toolbarItem => (
            <ToggleButton
              toolbarItem={toolbarItem}
              onClick={(e: $TSFixMe) => onButtonClick(addButton, e)}
            />
          ),
        };
      }, {} as ToolbarButtonRenderers);
  }
}
